class CartRecommendations extends HTMLElement {

    constructor(){
        super();
        this.generateRecommendations();
    }

    generateRecommendations(){
        const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
        if ( cartItems.length > 0 ) {
            fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
                .then(response => response.text())
                .then(text => {
                    const innerHTML = new DOMParser()
                      .parseFromString(text, 'text/html')
                      .querySelector('[data-js-cart-recommendations-performed]');
                    const sidebar = document.getElementById('site-cart-sidebar');

                    if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
                        this.innerHTML = innerHTML.innerHTML;
                        this.bindUpsellButtons();
                        sidebar?.classList.add('has-upsells');
                    } else {
                        this.innerHTML = '';
                        sidebar?.classList.remove('has-upsells');
                    }
                })
                .catch(()=> {
                    this.innerHTML = '';
                    document.getElementById('site-cart-sidebar')?.classList.remove('has-upsells');
                });
        } else {
            this.innerHTML = '';
            document.getElementById('site-cart-sidebar')?.classList.remove('has-upsells');
        }
    }

    // Attach click handlers for upsell buttons
    bindUpsellButtons() {
        this.querySelectorAll('.js-upsell-atc').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (btn.disabled) return;

                const hasVariants = String(btn.dataset.hasVariants) === 'true';
                const handle = btn.dataset.productHandle;
                const defaultVariantId = btn.dataset.defaultVariantId;

                if (hasVariants) {
                    this.openVariantPicker(handle, defaultVariantId);
                } else {
                    this.addVariantToCart(defaultVariantId, btn);
                }
            }, { passive: false });
        });
    }

    // Add a variant to cart via AJAX
    addVariantToCart(variantId, sourceButton) {
        if (!variantId) return;

        const setLoading = (el, isLoading) => {
            if (!el) return;
            el.disabled = isLoading;
            el.classList.toggle('is-loading', isLoading);
            el.classList.toggle('working', isLoading);
            el.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        };

        setLoading(sourceButton, true);

        return fetch(KROWN.settings.routes.cart_add_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
        .then(async (res) => {
            if (!res.ok) {
                let msg = 'Error adding to cart';
                try { const j = await res.json(); msg = j?.description || j?.message || msg; } catch(e){}
                throw new Error(msg);
            }
            return res.json();
        })
        .then(() => {
            if (typeof window.refreshCart === 'function') {
                window.refreshCart();
            }
        })
        .catch(err => {
            console.warn(err);
        })
        .finally(() => {
            setLoading(sourceButton, false);
        });
    }

    openVariantPicker(handle, defaultVariantId) {
      if (!handle) return;

      fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' }})

        .then(res => res.json())
        .then(product => {
          const container = document.getElementById('site-cart-sidebar') || document.body;

          const moneyFormat = KROWN?.settings?.shop_money_format || '${{amount}}';
          const formatWithDelimiters = (cents, precision = 2, thousands = ',', decimal = '.') => {
            if (isNaN(cents) || cents == null) return '0';
            const value = (cents / 100).toFixed(precision);
            const parts = value.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return precision ? parts[0] + decimal + parts[1] : parts[0];
          };
          const formatMoney = (cents) => {
            try {
              if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                return Shopify.formatMoney(cents, moneyFormat);
              }
            } catch(e){}
            return moneyFormat
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, formatWithDelimiters(cents, 0, '.', ','))

              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, formatWithDelimiters(cents, 0))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatWithDelimiters(cents, 2, '.', ','))

              .replace(/\{\{\s*amount\s*\}\}/, formatWithDelimiters(cents, 2));
          };

          const overlay = document.createElement('div');
          overlay.className = 'upsell-variant-modal';
          overlay.setAttribute('role', 'dialog');
          overlay.setAttribute('aria-modal', 'true');
          overlay.setAttribute('aria-label', `Choose a variant for ${product.title}`);

          const panel = document.createElement('div');
          panel.className = 'upsell-variant-modal__panel';

          const selectId = `upsell-variant-${product.id}`;

          const getOptionTitle = (p) => {
            const raw = p.options || p.options_with_values || [];
            let names = [];
            if (Array.isArray(raw) && raw.length) {
              if (typeof raw[0] === 'string') {
                names = raw;
              } else {
                names = raw.map(o => o?.name || o?.option_name).filter(Boolean);
              }
            }
            let title = names.length ? (names.length === 1 ? names[0] : names.join(' / ')) : 'Variant';
            if (title === 'Title' || title === 'Default Title') title = 'Variant';
            return title;
          };
          const optionTitle = getOptionTitle(product);

          const headerLabel = document.createElement('label');
          headerLabel.className = 'upsell-variant-modal__header';
          headerLabel.setAttribute('for', selectId);
          headerLabel.textContent = `Select ${optionTitle}`;

          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'upsell-variant-modal__close';
          closeBtn.innerHTML = KROWN?.settings?.symbols?.close || '×';
          closeBtn.addEventListener('click', () => overlay.remove());

          const field = document.createElement('div');
          field.className = 'upsell-variant-modal__field';

          const select = document.createElement('select');
          select.id = selectId;
          select.className = 'upsell-variant-modal__select';

          let initialVariant = null;
          const defaultIdNum = defaultVariantId ? Number(defaultVariantId) : null;
          product.variants.forEach(v => {
            const opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = (v.title === 'Default Title' ? 'Default' : v.title);
            opt.disabled = !v.available;
            opt.dataset.available = v.available ? 'true' : 'false';
            opt.dataset.price = v.price; // cents
            if (!initialVariant) initialVariant = v.available ? v : null;
            if (defaultIdNum && v.id === defaultIdNum) {
              initialVariant = v;
            }
            select.appendChild(opt);
          });

          let selectedVariant = initialVariant || product.variants[0];
          if (selectedVariant) {
            select.value = String(selectedVariant.id);
          }

          const submit = document.createElement('button');
          submit.type = 'button';
          submit.className = 'button button--blue button--fullwidth button--loader upsell-variant-modal__submit';
          const setSubmitState = (v) => {
            const priceText = v ? formatMoney(v.price) : '';
            submit.textContent = `Add to basket - ${priceText}`;
            const available = !!(v && v.available);
            submit.disabled = !available;
            submit.setAttribute('aria-disabled', available ? 'false' : 'true');
          };
          setSubmitState(selectedVariant);

          select.addEventListener('change', () => {
            const vId = Number(select.value);
            const v = product.variants.find(x => x.id === vId);
            selectedVariant = v || null;
            setSubmitState(selectedVariant);
          });

          submit.addEventListener('click', () => {
            if (!selectedVariant) return;
            this.addVariantToCart(selectedVariant.id, submit)
              .then(() => overlay.remove());
          });

          panel.appendChild(headerLabel);   
          panel.appendChild(closeBtn);      
          field.appendChild(select);
          panel.appendChild(field);
          panel.appendChild(submit);
          overlay.appendChild(panel);

          overlay.addEventListener('click', (e) => {
            if (e.target === overlay) overlay.remove();
          });

          container.appendChild(overlay);

          select.focus();
        })
        .catch(err => console.warn('Failed to load product variants', err));
    }
}
customElements.define('cart-recommendations', CartRecommendations);